module.exports = __webpack_public_path__ + "img/OK.131b16d8.png";